var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"list-item",class:{ 'clickable': _vm.isClickable },attrs:{"custom":"","to":{ name: _vm.route, params: { id: _vm.item.id }}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }